// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__yQ8xV","item":"PaymentsMobile_item__2d-LW","label":"PaymentsMobile_label__3mi75","amount":"PaymentsMobile_amount__1V5xi"};